<script lang="ts" setup>
function reload() {
    window.location.reload();
}
</script>

<template>
    <div class="flex h-screen flex-col items-center justify-center gap-4 p-4 text-center">
        <h1 class="text-2xl font-bold">Failed to load page</h1>
        <p class="text-base-content/70 max-w-md">
            The page could not be loaded. This can happen due to a network issue, an ad blocker, or a recent app update.
        </p>
        <button
            class="btn btn-primary"
            @click="reload">
            Reload page
        </button>
    </div>
</template>
